import React, { createContext, useContext, useState } from 'react';

const FullScreenSearchContext = createContext();

// .
export const FullScreenSearchProvider = ({ children }) => {
  const [showSearchFullScreen, setShowSearchFullScreen] = useState(false);

  return (
    <FullScreenSearchContext.Provider value={{ showSearchFullScreen, setShowSearchFullScreen }}>
      {children}
    </FullScreenSearchContext.Provider>
  );
};

export const useFullScreenSearch = () => useContext(FullScreenSearchContext);
